import { render, staticRenderFns } from "./ArticleComponent.vue?vue&type=template&id=563ddd71&scoped=true&"
import script from "./ArticleComponent.vue?vue&type=script&lang=js&"
export * from "./ArticleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ddd71",
  null
  
)

export default component.exports